import { Radio, RadioProps } from "antd";
import { useTranslation } from "react-i18next";

// todo Radio ui style

export function ExportForm({ onChange, value }: RadioProps) {
  const { t } = useTranslation("center");
  return (
    <Radio.Group onChange={onChange} value={value}>
      <Radio value={0}>{t("user_consume_pick_output_option_a")}</Radio>
      <Radio value={1}>{t("user_consume_pick_output_option_b")}</Radio>
    </Radio.Group>
  );
}
